export default "__VITE_ASSET__BdHq3M$v__"